<script setup lang="ts">
/**
 * Bannière "66% déductible des impôts" + mention reçu fiscal.
 * Partagé entre /a/[slug] (adhésion) et /b/[slug] (événement).
 */
defineProps<{
  label?: string;
}>();
</script>

<template>
  <div class="rounded-3xl bg-white dark:bg-[#141414] border border-gray-200 dark:border-gray-800 shadow-[0_2px_8px_rgba(0,0,0,0.04)] px-4 py-4 lg:p-5">
    <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
      {{ label || $t("association.publicPage.deductibleMontant") }}
    </p>
    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
      {{ $t("association.publicPage.recuFiscalInfo") }}
    </p>
  </div>
</template>
